import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from 'components/widgets/Container';
import SettingsStyles from 'styles/modules/settings/SettingsStyles';
import {
    List, ListItem, ListItemIcon, ListItemText,
} from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';
// utils
import KeyStore from 'utils/KeyStore';
import Permission from 'utils/enum/Permissions';
import {
    ListAltOutlinedIcon,
    TuneOutlinedIcon,
} from 'components/icons';
import CompanySettingCategory, { CompanySettingkey } from 'utils/enum/CompanySettingEnum';
import RoleBuilder from 'components/widgets/settings/RoleBuilder';
import PartsSettingsLayout from 'components/modules/settings/parts/PartsSettingsLayout';
import PartsDefaultSettings from './PartsDefaultSettings';

const useStyles = makeStyles((theme) => SettingsStyles.settingsPanelItem(theme));
const subTabs = [];
const getSelectedTab = (subtab) => {
    const tabIndex = subTabs.indexOf(subtab);
    if (tabIndex !== -1) return tabIndex;

    return 0;
};

const getSettings = () => {
    const keyStore = new KeyStore();
    const settings = [];

    if (keyStore.hasPermission(Permission.PARTS_READ)) {
        settings.push(
            {
                index: 0,
                text: 'Default Settings',
                icon: <TuneOutlinedIcon />,
                component: <PartsDefaultSettings />,
            },
            {
                index: 1,
                text: 'Catalogs',
                icon: <ListAltOutlinedIcon />,
                component: <PartsSettingsLayout />,
            },
            {
                index: 2,
                text: 'Parts Clerk',
                icon: <TuneOutlinedIcon />,
                component: <RoleBuilder
                    canWrite
                    category={CompanySettingCategory.PARTS}
                    property={CompanySettingkey.PARTS_CLERK_GLOBAL_ROLE}
                />,
            },
        );
        subTabs.push('default', 'catalogs', 'parts-clerk');
    }

    return settings;
};

const PartsSettings = () => {
    const classes = useStyles();
    const history = useHistory();
    const { maintab, subtab } = useParams();

    const [activeIndex, setActiveIndex] = useState(getSelectedTab(subtab || 0));

    const handleChange = (newIndex) => {
        history.push(`/settings/${maintab}/${subTabs[newIndex]}`);
        setActiveIndex(newIndex);
    };

    const settingsItems = getSettings();

    return (
        <>
            <Container className={classes.rootContainer}>
                <List component="nav" className={classes.sideBar}>
                    {settingsItems.map((item) => (
                        <ListItem key={item.index} onClick={() => handleChange(item.index)} button selected={activeIndex === item.index}>
                            <ListItemIcon>
                                {item.icon}
                            </ListItemIcon>
                            <ListItemText primary={item.text} />
                        </ListItem>
                    ))}
                </List>
                <div className={classes.content}>
                    {settingsItems.map((item) => (
                        activeIndex === item.index && <div key={item.index}>{item.component}</div>
                    ))}
                </div>
            </Container>
        </>
    );
};

export default PartsSettings;
